import React, { useCallback, useEffect, useState, isValidElement } from 'react'
import {
  clearToken,
  errorMessages,
  getToken,
  setToken,
  fetchWithToken,
  createEndPoint
} from '../../services/util'
import LoginForm from './components/loginForm/LoginForm'
import {
  login,
  loginProvider,
  loginWithLayers,
  loginWithCodeLayers
} from '../../services/loginService'
import { useHistory, useLocation } from 'react-router-dom'
import BBCoverImg from '../../assets/img/bg-login.png'
import { ReactComponent as LogoSimple } from '../../assets/img/logotipo_morado.svg'
import { ReactComponent as OCLogo } from '../../assets/img/logo_OC.svg'
import FormButton from '../BlueberryFamilyPages/components/FormButton/FormButton'

import './login-page.scss'
import translate from '../../i18n/translate'
import { resetStore } from '../../store/configureStore'
import { setCourseGuid, setSchoolGroup } from '../../assets/data/api'
import usePopupManager from '../../modules/components/PopupManager/usePopupManager'
import { getCourseInfo, getWhoAmI } from '../../services/courseInfoService'
import { getSettings, updateSettings } from '../../services/settingsService'
import {
  clearLocalPetAvatar,
  updateRewardsSettings
} from '../../services/rewardsService'
import AccessHelper from '../../services/util/accessHelper'
import Loading from '../../modules/components/Loading/Loading'
import { GoogleLogin } from '@react-oauth/google'
import {
  resetPlayerState,
  sendMagicLinkEmail,
  saveUserLocalePreferences
} from '../../services/userManagementService'
import { detectLanguage, detectCountry } from '../../services/localeService'
import { enableQAMode, isQAMode } from '../../services/qaModeService'
import { Analysis } from '../../services/analysisService'
import {
  getSourceMetadataParams,
  getSourceInfoParam
} from '../../services/sourceService'
import { isDeviceSupported } from '../../util/devices'
import { getSsoAppParams } from '../../config/constants/appSchemesAndStoreUrls'
import SelectRegion from './components/SelectRegion/SelectRegion'
import { customStorage } from '../../util/customStorage'
import { useIsMobile } from '../../hooks/useIsMobile'

function LogoBB() {
  return (
    <div className="login-page__bb-logo-container">
      <LogoSimple className="login-page__bb-logo" alt="Blueberry Math" />
    </div>
  )
}

function LoginPage({ isLoginQA, isBlueberryFamily }) {
  const history = useHistory()
  const location = useLocation()

  const { resetPopupStore } = usePopupManager()
  const [isErrorFromToken, setIsErrorFromToken] = useState(false)
  const [isErrorFromGoogle, setIsErrorFromGoogle] = useState(false)
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [shouldHideLoginForm, setShouldHideLoginForm] = useState(true)
  const [isWaitingFromServerResponse, setIsWaitingFromServerResponse] =
    useState(false)

  const [errorUser, setErrorUser] = useState(false)

  const [loginRegion, setLoginRegion] = useState(null)

  const [isDomainLayers, setIsDomainLayers] = useState(false)
  const [isValidElementLayers, setIsValidElementLayers] = useState(false)

  const [urlHost] = useState(
    `${window.location.protocol}//${window.location.host}/`
  )

  const isMobile = useIsMobile()

  useEffect(() => {
    console.log('Esta en LoginPage')
    // Cargar el script de LayersAuth
    const script = document.createElement('script')
    script.src = 'https://js.layers.digital/v1/LayersAuth.js'
    script.async = true
    document.body.appendChild(script)

    setIsValidElementLayers(isValidElement(<layers-auth-button />))

    // Temporal - para el cambio de urls de tener # a no tener y ser llamadas desde APPs
    if (window?.ReactNativeWebView?.postMessage) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ function: 'isNotPractice' })
      )
    }

    Analysis.sendSegmentPageEvent(
      Analysis.SEGMENT_PAGE_CATEGORIES.Signin,
      Analysis.SEGMENT_EVENTS['Log In Form Viewed']
    )

    // fallback function to hande # in the url because params are not a searchParam if it has a #
    const extractParamFromUrl = (url, propertyName) => {
      // Use a more specific regular expression to match the 'token' parameter
      const regex = new RegExp(`${propertyName}=([^&]+)`)
      const match = url.match(regex)

      if (match) {
        return match[1] // Return the captured value directly
      } else {
        return undefined // Return undefined if not found
      }
    }

    // Check if the url contains a token or an error 1/2
    const url = new URL(window.location.href)
    const layersSession = url.searchParams.get('layers_session')
    const ssoToken =
      url.searchParams.get('token') ||
      extractParamFromUrl(window.location.href, 'token')
    const courseGuid =
      url.searchParams.get('courseGuid') ||
      extractParamFromUrl(window.location.href, 'courseGuid')
    const shortToken = location.search.includes('shortToken')
      ? location.search.substring(1).split('=')[1]
      : null

    const ssoCodeLayers =
      url.searchParams.get('code') ||
      extractParamFromUrl(window.location.href, 'code')

    if (isLoginQA) {
      enableQAMode()
    }

    if (isQAMode()) {
      ocLog('👻 %cGhost Mode', 'color: blueviolet; font-weight:bold')
    }

    const hasToLoginFromOutside = !!(
      layersSession ||
      ssoToken ||
      shortToken ||
      ssoCodeLayers
    )

    // Login por algún tipo de token "externo"
    if (hasToLoginFromOutside) {
      console.log('Está en hasToLoginFromOutside')
      clearToken()
      window.localStorage.removeItem('bb_game_initialized')

      if (layersSession) {
        loginWithLayersSession()
      } else if (ssoToken) {
        loginWithSSoToken(ssoToken, courseGuid)
      } else if (shortToken) {
        loginWithShortToken(shortToken)
      } else if (ssoCodeLayers) {
        loginWithCodeLayersSSO(ssoCodeLayers)
      }
    }
    // Login por token guardado previamente
    else if (getToken()) {
      history.push('/game')
    }
    // Comprobación de errores en URL o esperara acción de usuario en pantalla Login
    else {
      const errorMessage = url.searchParams.get('error')

      if (errorMessage) {
        setIsErrorFromToken(true)
        // Display the error message
        const formattedErrorMessage = decodeURIComponent(errorMessage)
        // check if error is not found then redirect to 404 page
        if (formattedErrorMessage.toLowerCase().indexOf('not_found') > -1) {
          errorRedirectUser('405')
        } else {
          errorRedirectUser('500')
        }
      } else {
        // No token or error found, do nothing
        setIsLoading(false)
        setShouldHideLoginForm(false)
        checkIfThirdPartDomain()
      }
    }

    if (url.hostname === 'layers.blueberry.app.br') {
      setIsDomainLayers(true)
    } else {
      setIsDomainLayers(false)
    }
  }, [])

  const checkCookie = useCallback(() => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(true)
      }, 300)
    })
  }, [])

  const loginWithLayersSession = async () => {
    const url = new URL(window.location.href)

    const layersSession = url.searchParams.get('layers_session')
    const layersUserId = url.searchParams.get('layers_user_id')
    const layersCommunityId = url.searchParams.get('layers_community_id')

    const loginResponse = await loginWithLayers({
      layersSession,
      layersUserId,
      layersCommunityId
    })

    if (loginResponse?.token) {
      const token = loginResponse?.token
      loginWithSSoToken(token)
    } else {
      errorRedirectUser('405-contact')
    }
  }

  const loginWithCodeLayersSSO = async (codeLayers) => {
    const loginResponse = await loginWithCodeLayers({
      codeLayers,
      urlHost
    })

    try {
      await preLogin()
      await loginProvider(loginResponse.access_token, 'layers')
      storeLoginRegion()
      await postLogin(AccessHelper.ACCESS_TYPE_LAYERS_SSO, false, true)
    } catch (error) {
      console.error('- Login with Layers error (s): ', error)

      if (error === errorMessages.USER_NOT_FOUND) {
        setError(translate('LOGIN_PROVIDER_ERROR_USER_NOT_FOUND'))
        errorRedirectUser('405', true)
      } else {
        setError(translate('LOGIN_LAYERS_ERROR'))
        errorRedirectUser('405', true) // TODO: Este debería ser otro mensaje, pero no tenemos uno genérico
      }
    }
  }

  const getTeacherDashboardUrl = (token) => {
    const { protocol, hostname: rawHostname } = window.location
    const hostname =
      rawHostname !== 'localhost'
        ? rawHostname
        : 'school.blueberry-dev.oneclicklabs.es'

    return `${protocol}//dashboard.${hostname}?token=${token}`
  }

  const loginWithSSoToken = async (ssoToken, courseGuid) => {
    console.log('Está en loginWithSSoToken')
    setIsLoading(true)
    setShouldHideLoginForm(true)
    // FYI: Token is set multiple times because component state updates resets the token

    // Set the token in the local storage
    setToken(ssoToken)

    // check if the user is a teacher or a student and redirect to the correct page
    // use the whoami endpoint to get the user role
    const whoAmI = await getWhoAmI(true)
    const role = whoAmI.role_guid
    const isTeacher = role === 'R02'

    if (isTeacher && !courseGuid) {
      // redirect to teacher page
      window.location.href = getTeacherDashboardUrl(ssoToken)
      // clearing the token to logout the teacher from the student page
      console.log('Está en loginWithSSoToken isTeacher && !courseGuid')
      clearToken()
      return
    }

    // get settings from the server
    const settings = await getSettings(ssoToken)
    updateSettings({
      ...settings.data,
      loggedInViaToken: true,
      isTeacher: isTeacher
    })

    // Solicitar settings recompensas
    if (!isBlueberryFamily || whoAmI.role_guid !== 'R03') {
      clearLocalPetAvatar()
      const memberRewardsSettings = await fetchWithToken(
        createEndPoint('users/rewards-settings')
      )
      updateRewardsSettings(memberRewardsSettings.data)
    }

    if (isTeacher && courseGuid) {
      setCourseGuid(courseGuid)
    } else {
      // get the course info
      const courseInfo = await getCourseInfo()
      if (courseInfo) {
        setCourseGuid(courseInfo.courseGuid)
        setSchoolGroup(courseInfo.schoolGroup)
      } else {
        window.location.href = `${window.location.protocol}//${window.location.host}/error-405`
      }
    }
    setToken(ssoToken)

    resetStore()
    resetPopupStore()

    AccessHelper.setAccessInformation(true, AccessHelper.ACCESS_TYPE_BB_SSO)

    // Si es SSO pasa por la pantalla de inicio
    goToSsoStartPage()
  }

  const goToSsoStartPage = () => {
    const auxHost = window.location.host
    const ssoSourceName = auxHost.includes('layers')
      ? 'layers'
      : auxHost.includes('positivo')
      ? 'positivo'
      : 'blueberrySso'
    const ssoUrlParams =
      '?ssoSource=' + ssoSourceName + getSsoAppParams(ssoSourceName)

    const _search = window.location.search
    const [, params] = _search.split('?')
    const fullParams = ssoUrlParams + (params ? '&' + params : '')

    if (isDeviceSupported()) {
      // Se resetea el GUID del curso y el estado del store y establecer acceso reciente y tipo
      // resetPlayerState()
      // history.replace('/title' + fullParams)
      window.location =
        window.location.protocol +
        '//' +
        window.location.host +
        '/title' +
        fullParams
    } else {
      const isBlueberryFamily = window?.organizationData?.isBlueberryFamily

      if (isBlueberryFamily) {
        sendMagicLinkEmail()
        // history.replace({ pathname: '/unsupported' + fullParams })
        window.location =
          window.location.protocol +
          '//' +
          window.location.host +
          '/unsupported' +
          fullParams
      } else {
        // history.replace({ pathname: '/download-app' + fullParams })
        window.location =
          window.location.protocol +
          '//' +
          window.location.host +
          '/download-app' +
          fullParams
      }
    }
  }

  const preLogin = () => {
    setError('')
    setIsWaitingFromServerResponse(true)
    setIsErrorFromGoogle(false)
  }

  const postLogin = async (accessType, isCustomSso, isLoginViaProvider) => {
    const isMainUser = true
    const whoAmI = await getWhoAmI(isMainUser)
    const userToken = getToken(isMainUser)

    // Detect and save locale preferences
    // - lang_id: ONLY if not already set (respect user's manual selection)
    // - country_guid: ALWAYS update (okay to override)
    const langId = !whoAmI.lang_id ? detectLanguage() : null
    const countryGuid = await detectCountry(loginRegion) // Prioritize user's region selection

    if (langId || countryGuid) {
      saveUserLocalePreferences(langId, countryGuid) // Fire-and-forget
    }

    // Solicitar settings recompensas si no es un padre
    if (
      !isLoginViaProvider &&
      (!isBlueberryFamily || whoAmI.role_guid !== 'R03')
    ) {
      // role_name:  "School Admin"
      try {
        clearLocalPetAvatar()
        const memberRewardsSettings = await fetchWithToken(
          createEndPoint('users/rewards-settings')
        )

        updateRewardsSettings(memberRewardsSettings.data)
      } catch (r) {
        console.error('Error al obtener los settings de recompensas', r)
      }
    }

    // Para analisis
    const sourceMetadata = JSON.parse(getSourceMetadataParams())
    const metadataDeconstruction = {}
    Object.keys(sourceMetadata).forEach((key) => {
      metadataDeconstruction['analytics_metadata_' + key] = sourceMetadata[key]
    })

    Analysis.sendEvent(Analysis.EVENT.LOGIN, {
      sourceOfUser: getSourceInfoParam(),
      ...metadataDeconstruction
    })
    // Fin analisis --------------------------------------------------

    // check if the user is a teacher or a student and redirect to the correct page
    // use the whoami endpoint to get the user role
    const role = whoAmI.role_guid
    const isTeacher = role === 'R02'

    if (isTeacher && userToken) {
      // redirect to teacher page
      window.location.href = getTeacherDashboardUrl(userToken)
      // clearing the token to logout the teacher from the student page
      console.log('Está en postLogin clearToken')
      clearToken()
      return
    }

    // Por si hay cambio de usuario (ej: familiares con mismo dispositivo)
    // Se resetea el GUID del curso y el estado del store y establecer acceso reciente y tipo
    // resetPlayerState()
    resetPopupStore()
    AccessHelper.setAccessInformation(true, accessType)

    // Si hay cambio de idioma, se recarga la página
    if (whoAmI?.reloadForLanguage) {
      window.location.reload()
      return
    }

    // Redireccionar a inicio
    if (!isCustomSso) {
      setTimeout(() => {
        history.replace('/game')
      }, 10)
    } else {
      // Se resetea el GUID del curso y el estado del store y establecer acceso reciente y tipo
      resetPlayerState()
      // Si es con token pasa por la pantalla de inicio (si no, audio no funciona)
      goToSsoStartPage()
    }
  }

  const storeLoginRegion = () => {
    // Tras hacer login, se guarda la región que el usuario utilizó
    customStorage.set('bb_user_region_allowed', loginRegion)
  }

  const credentialsLogin = useCallback(
    async (credentials) => {
      try {
        await preLogin()
        await login(credentials)
        storeLoginRegion()
        await postLogin(AccessHelper.ACCESS_TYPE_CREDENTIALS)
      } catch (error) {
        switch (error) {
          case errorMessages.LOGIN_ERROR:
            setError(translate('LOGIN_CREDENTIALS_ERROR'))
            break

          case errorMessages.USER_NOT_FOUND:
            setErrorUser(true)
            setError(translate('LOGIN_PROVIDER_ERROR_USER_NOT_FOUND'))
            break

          case errorMessages.PASS_INCORRECT:
            setErrorUser(false)
            setError(translate('LOGIN_CREDENTIALS_ERROR'))
            break

          case errorMessages.LOGIN_WRONG_FORMAT:
            setErrorUser(false)
            setError(translate('LOGIN_WRONG_FORMAT'))
            break

          case undefined:
            setErrorUser(false)
            setError(translate('LOGIN_PROVIDER_ERROR_USER_NOT_FOUND'))
            break

          default:
            setErrorUser(false)
            setError(translate('LOGIN_INTERNET_ERROR'))
            break
        }

        setIsWaitingFromServerResponse(false)

        // errorRedirectUser('405', true)
      }
    },
    [
      setError,
      history,
      checkCookie,
      setIsWaitingFromServerResponse,
      loginRegion
    ]
  )

  // check if the domains are positivo-hml.blueberry.app.br and positivo.blueberry.app.br and redirect to 405 page if they are
  const checkIfThirdPartDomain = () => {
    const thirdPartyDomains = [
      'positivo-hml.blueberry.app.br',
      'positivo.blueberry.app.br'
      // 'layers.blueberry.app.br'
    ]
    const isThirdPartyDomain = thirdPartyDomains.includes(window.location.host)
    if (isThirdPartyDomain) {
      errorRedirectUser('405')
    }
  }

  const loginWithShortToken = async (shortToken) => {
    try {
      await preLogin()

      const shortTokenResponse = await loginProvider(shortToken, 'i2c')

      if (shortTokenResponse.error) {
        throw Error(shortTokenResponse.error)
      }

      storeLoginRegion()
      await postLogin(AccessHelper.ACCESS_TYPE_GOOGLE_SSO, true, true)

      setIsWaitingFromServerResponse(false)
    } catch (error) {
      console.error('loginWithShortToken ', error)
      if (error === errorMessages.USER_NOT_FOUND) {
        setError(translate('LOGIN_PROVIDER_ERROR_USER_NOT_FOUND'))
        errorRedirectUser('405', true)
      } else {
        setError(translate('LOGIN_INTERNET_ERROR'))
        errorRedirectUser('token', true) // TODO: Este debería ser otro mensaje, pero no tenemos uno genérico
      }
    }
  }

  const googleSuccessHandler = async (result) => {
    try {
      await preLogin()
      await loginProvider(result.credential, 'google')
      storeLoginRegion()
      await postLogin(AccessHelper.ACCESS_TYPE_GOOGLE_SSO, false, true)
    } catch (error) {
      console.error('- Login with Google error (s): ', error)

      if (error === errorMessages.USER_NOT_FOUND) {
        setError(translate('LOGIN_PROVIDER_ERROR_USER_NOT_FOUND'))
        errorRedirectUser('405', true)
      } else {
        setError(translate('LOGIN_GOOGLE_ERROR'))
        errorRedirectUser('405', true) // TODO: Este debería ser otro mensaje, pero no tenemos uno genérico
      }
    }

    setIsErrorFromGoogle(true)
    setIsWaitingFromServerResponse(false)
  }

  const googleErrorHandler = (error) => {
    console.error('- Login with Google error (e): ', error)

    setIsErrorFromGoogle(true)
    setError(translate('LOGIN_GOOGLE_ERROR'))

    errorRedirectUser('500', true) // TODO: Este me parece el más apropiado, pero tampoco es lo mejor
  }

  // Redirige a pantalla informativa
  // errorType:
  //   '404' not found
  //   '405' user not found
  //   '405-contact' user not found, contact school admin
  //   '500' network problem
  const errorRedirectUser = (errorType, hasReturnButton) => {
    const url =
      errorType !== 'token' ? '/error-' + errorType : '/error-token-expired'
    const returnParameter = hasReturnButton === true ? '?return=true' : ''

    // window.location.href = url + returnParameter
    window.location.href = `${window.location.protocol}//${window.location.host}${url}${returnParameter}`
  }

  return (
    <div className="login-page">
      {!isMobile && (
        <>
          <img
            className="login-page__cover-img"
            src={BBCoverImg}
            alt="Blueberry background"
          />
          <img
            className="login-page_rocket"
            src="/assets/graphics/images/rocket.png"
            alt="Rocket"
          />
        </>
      )}

      <div className="login-page_scroll-container">
        {!shouldHideLoginForm && (
          <div className="login-page__container">
            {isMobile && (
              <div className="login-page_header-mobile">
                <LogoBB />
              </div>
            )}
            <img
              className="login-page_luna"
              src="/assets/graphics/images/luna.png"
              alt="Luna"
            />
            {isMobile && (
              <img
                className="login-page_rocket"
                src="/assets/graphics/images/rocket.png"
                alt="Rocket"
              />
            )}
            {!isMobile && <LogoBB />}
            <div className="login-page-content">
              <div className="login-page__login-form" data-testid="login_form">
                <h2 className="login-title">{translate('login')}</h2>

                <SelectRegion setParentRegion={setLoginRegion} />

                <div className="login-page__google-button-container">
                  <GoogleLogin
                    shape="pill"
                    className="login-page__google-button"
                    logo_alignment="left"
                    size="medium"
                    width="310px"
                    onSuccess={googleSuccessHandler}
                    onError={googleErrorHandler}
                    data-testid="login_form_google"
                  />
                </div>

                {isDomainLayers && isValidElementLayers && (
                  <div className="login-page__layers-button-container">
                    <layers-auth-button
                      client-id="blueberry"
                      scope="openid email profile fullname related.communities"
                      response-type="code"
                      redirect-uri={urlHost}
                      label={translate('login_text')}
                    />
                  </div>
                )}

                <div className="login-page__separator">
                  <span className="login-page__separator-line"></span>
                  <span className="login-page__separator-text">
                    {translate('or_separator')}
                  </span>
                  <span className="login-page__separator-line"></span>
                </div>

                <LoginForm
                  onSubmit={credentialsLogin}
                  error={!isErrorFromToken && !isErrorFromGoogle && error}
                  isWaitingFromServerResponse={isWaitingFromServerResponse}
                  isBlueberryFamily={isBlueberryFamily}
                  errorUser={errorUser}
                />

                {isBlueberryFamily && (
                  <div className="login-page__signup-button">
                    <FormButton
                      variant="transparent"
                      text={translate('family_home_signup')}
                      onClick={() => {
                        history.replace('/blueberry-family-signup')
                      }}
                    />
                  </div>
                )}
              </div>
              <div className="login-page__oc-logo">
                <OCLogo />
              </div>
            </div>
          </div>
        )}
      </div>
      {isLoading && (
        <div className="login-page__loading">
          <Loading />
        </div>
      )}
    </div>
  )
}

export default LoginPage
